export var GiftCardType;
(function (GiftCardType) {
    GiftCardType["GIFT_CARD"] = "gift_card";
})(GiftCardType || (GiftCardType = {}));
